import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Context
import { AuthProvider } from "./context/AuthContext";

// Components
import Navigation from "./components/shared/Navigation";
import ProtectedRoute from "./components/shared/ProtectedRoute";

// Pages
import HomePage from "./pages/HomePage";
import CalendarPage from "./pages/CalendarPage";
import BookPage from "./pages/BookPage";
import GalleryPage from "./pages/GalleryPage";
import LinksPage from "./pages/LinksPage";
import MembersPage from "./pages/MembersPage";
import ClubMembersPage from "./pages/ClubMembersPage";
import WebshopPage from "./pages/WebshopPage";
import MotoGamePage from "./pages/MotoGamePage";
import MembershipPage from "./pages/MembershipPage";
import ContactPage from "./pages/ContactPage";
import ContactFindUsPage from "./pages/ContactFindUsPage";
import KlubbenPage from "./pages/KlubbenPage";
import AndreKlubberPage from "./pages/AndreKlubberPage";
import LoginPage from "./pages/LoginPage";
import CoinsPage from "./pages/CoinsPage";
import ProfilePage from "./pages/ProfilePage";
import AuditLogPage from "./pages/AuditLogPage";
import TosPage from "./pages/TosPage";
import BordbestillingPage from "./pages/BordbestillingPage";
import FoodReceiptPage from "./pages/FoodReceiptPage";
import CoinReceiptPage from "./pages/CoinReceiptPage";
import FoodPaymentsPage from "./pages/FoodPaymentsPage";

function AppRouter() {
  return (
    <>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/kalender" element={<CalendarPage />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="/galleri" element={<GalleryPage />} />
        <Route path="/mediegarage" element={<LinksPage />} />
        <Route path="/medlemmer" element={<ProtectedRoute requireAdmin={true}><MembersPage /></ProtectedRoute>} />
        <Route path="/klubmedlemmer" element={<ClubMembersPage />} />
        <Route path="/webshop" element={<ProtectedRoute><WebshopPage /></ProtectedRoute>} />
        <Route path="/spil" element={<ProtectedRoute><MotoGamePage /></ProtectedRoute>} />
        <Route path="/medlemskab" element={<MembershipPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/kontakt-os" element={<ContactFindUsPage />} />
        <Route path="/klubben" element={<KlubbenPage />} />
        <Route path="/andre-klubber" element={<AndreKlubberPage />} />
        <Route path="/monter" element={<CoinsPage />} />
        <Route path="/monter/kvittering" element={<CoinReceiptPage />} />
        <Route path="/profil" element={<ProfilePage />} />
        <Route path="/aktivitetslog" element={<ProtectedRoute requireAdmin={true}><AuditLogPage /></ProtectedRoute>} />
        <Route path="/tos" element={<ProtectedRoute><TosPage /></ProtectedRoute>} />
        <Route path="/bordbestilling" element={<ProtectedRoute><BordbestillingPage /></ProtectedRoute>} />
        <Route path="/bordbestilling/kvittering" element={<FoodReceiptPage />} />
        <Route path="/mad-betalinger" element={<ProtectedRoute><FoodPaymentsPage /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              background: '#1a1a1a',
              border: '1px solid #262626',
              color: '#f3f4f6',
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
